import { render, staticRenderFns } from "./AdditionalTabs.vue?vue&type=template&id=aeef4d9c&scoped=true"
import script from "./AdditionalTabs.vue?vue&type=script&lang=js"
export * from "./AdditionalTabs.vue?vue&type=script&lang=js"
import style0 from "./AdditionalTabs.vue?vue&type=style&index=0&id=aeef4d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeef4d9c",
  null
  
)

export default component.exports